import {
  Card,
  CardCaption,
  CardTitle,
  EducationScreen,
  FDARow,
  Gold,
  Registered,
  RevealBlock,
  ScreenBody,
  ScreenIntro,
  ScreenSubhead,
} from './EducationShell';
import {SleepBlocksViz, TimeInBedViz} from './Step8Viz';
import {ZepboundDisclaimer} from './ZepboundDisclaimer';

/** Step 8 — branded variant. Treatment intro: Zepbound®, first FDA-approved
 *  medication for severe sleep apnea. */
export const Glp1EducationIntroBranded = () => (
  <EducationScreen
    ctaLabel="Show me"
    variant="branded_v1"
    analyticsShown="GLP-1 Funnel Education Intro Viewed"
    analyticsSubmitted="GLP-1 Funnel Education Intro Show Me Tapped"
  >
    <ScreenIntro
      headline={
        <>
          <Gold>Zepbound</Gold>
          <Registered />
          <Gold>.</Gold> The first FDA-approved medication for severe sleep apnea.
        </>
      }
      subhead="For decades, CPAP was the only real option for severe apnea. In 2024, that changed."
    />

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          Zepbound
          <Registered size={9} /> reduces <Gold>breathing interruptions</Gold> by 55–63%.
        </CardTitle>
        <SleepBlocksViz delayMs={200} variant="branded" />
        <CardCaption>
          About 30 fewer breathing interruptions per hour with Zepbound®. SURMOUNT-OSA · NEJM, 2024
        </CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <FDARow text="Published in The New England Journal of Medicine and FDA approved" />
    </RevealBlock>

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          Time in bed becomes <Gold>restful sleep</Gold>
        </CardTitle>
        <TimeInBedViz delayMs={200} />
        <CardCaption>The hours you spend in bed finally start to count.</CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={300}>
      <ScreenSubhead>What it feels like.</ScreenSubhead>
      <ScreenBody>The exhaustion that&apos;s been there for years finally starts to lift.</ScreenBody>
    </RevealBlock>

    <RevealBlock delayMs={300}>
      <ZepboundDisclaimer />
    </RevealBlock>
  </EducationScreen>
);

export default Glp1EducationIntroBranded;
